module.exports = require("./lib/fortune-client");
module.exports.util = require("./lib/util");